import {
  EnergyType,
  promoCodesWithReferrals,
} from '@energy-retailer/constants';
import { z } from 'zod';

export const addPricingPlanSchema = z
  .object({
    energyType: z.nativeEnum(EnergyType),
    electricity_promo_code: z.string().optional(),
    gas_promo_code: z.string().optional(),
    referral_code: z.string().optional(),
    estimated_usage: z.number(),
    estimated_usage_units: z.string(),
  })
  .transform((data) => {
    switch (data.energyType) {
      case EnergyType.Electricity:
        if (
          data.referral_code &&
          promoCodesWithReferrals.includes(data.electricity_promo_code as any)
        ) {
          return {
            promo_code: data.electricity_promo_code,
            referral_code: data.referral_code,
            estimated_usage: data.estimated_usage,
            estimated_usage_units: data.estimated_usage_units,
          };
        }

        return {
          promo_code: data.electricity_promo_code,
          estimated_usage: data.estimated_usage,
          estimated_usage_units: data.estimated_usage_units,
        };
      case EnergyType.Gas:
        return {
          promo_code: data.gas_promo_code,
          estimated_usage: data.estimated_usage,
          estimated_usage_units: data.estimated_usage_units,
        };
    }
  });

export type AddPricingPlanSchema = z.infer<typeof addPricingPlanSchema>;
